module.exports = __webpack_public_path__ + "img/update-products.3e31911a.png";